module.exports = __webpack_public_path__ + "static/media/chat.bf593dd4.png";